import { container } from "tsyringe";
/**
 * ChatEventBusSocket - Represents a connection to chat from websocket
 */
export class BookInWebSocket {
    /**
     * Get singleton instance of ChatEventBusSocket
     * @returns ChatEventBusSocket
     */
    static getInstance() {
        if (this.instance === undefined) {
            this.instance = new BookInWebSocket();
        }
        return this.instance;
    }
    /**
     * Create a unique id for connection socket
     * @returns string Guid
     */
    createGuid() {
        const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        const guid = `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
        const guidSession = sessionStorage.getItem('guid');
        if (guidSession) {
            return guidSession;
        }
        sessionStorage.setItem('guid', guid);
        return guid;
    }
    /**
     * Constructor - Create conection to socket and solve ISocketmanager and IEventBus dependencies
     */
    constructor() {
        var gatewaySocket = process.env.REACT_APP_GATEWAY;
        this.socketId = `${gatewaySocket}/ws/RT/Eda/EdaSocket/Connect?id=${this.createGuid()}`;
        this._socketmanager = container.resolve('ISocketmanager');
        this._eventBus = container.resolve('IEventBus');
        this.connect();
    }
    /**
     * Create new connection to socket
     * @returns void
     */
    connect() {
        this._socketmanager.addSocket(this.socketId);
        this._socketmanager.getSocket(this.socketId).onMessage(this.onMessage.bind(this));
    }
    /**
     * Close connection to socket
     * @param socketId Socket Id to be closed
     * @returns void
     */
    disconnect() {
        this._socketmanager.removeSocket(this.socketId);
    }
    /**
     * Send message to socket
     * @returns void
     */
    send(message) {
        var socket = this._socketmanager.getSocket(this.socketId);
        if (!socket)
            console.log("Socket not found");
        socket.send(message);
    }
    /**
     * Received new message to socket
     * @param messageEvent Message received
     * @returns void
     */
    onMessage(messageEvent) {
        try {
            var obj = JSON.parse(messageEvent.data);
            if (obj.event !== undefined) {
                this._eventBus.dispatch(obj.event, JSON.parse(obj.data));
            }
        }
        catch (e) {
            console.log("Error on message");
        }
    }
}
BookInWebSocket.instance = undefined;
